import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Book() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Grid className="p-3" spacing={0} container direction="row" justify="start">
            <Grid item xs={12} md={4} className="p-2">
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                デーリー東北の書籍
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} className="p-2 fs90 line180">
              お求めは最寄りの書店、デーリー東北販売店、本社出版部で。<br />
              お問い合わせは本社出版部まで。<br />
              電話0178-80-7204（平日午前９時30分～午後５時）<br />
              ファクス0178-44-5126<br />
            </Grid>
          </Grid>
          <Box my={4}>
            <Paper>
              <List component="nav" aria-label="main mailbox folders">
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/pop-tantou.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2 text-danger" variant="body1" component="h2">
                        2022年9月22日発売
                      </Typography>
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「ポップ担当日記 まちの本屋と書店員の日常」<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        ポプ担 著<br />
                        Ａ５判／268ページ<br />
                        定価：1,980円（税込み）
                      </div>
                      <div class="fs90 line150 text-secondary">
                        青森県八戸市―。海に程近い、「ポップごと売る本屋」で働く著者は、ちょっとした「楽しかったこと探し」が得意。同僚やお客様との触れ合い、1人暮らしのおうち時間、休日の外出…。一見普通の日々の暮らしの中にも、小さな幸せがいっぱい。子ども時代の思い出や、時に奇想天外な妄想も、著者の世界を温かく彩ります。<br />
                        人気Twitter漫画の待望の書籍化。本好きな方はもちろん、本をあまり読まない人の心にも優しく響くエピソード満載。読めば笑顔になる、ほっこりコミックエッセーです。<br />
                        かわいいポップ（のようなカード）付き！<br />
                        {/* <br />
                        ※「47CLUB」のほか、デーリー東北ショッピングサイト（<a href="https://dt-picture.myshopify.com/">https://dt-picture.myshopify.com/</a>）でもご購入できます。<br /> */}

                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/shouwa-children.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2 text-danger" variant="body1" component="h2">
                        2021年12月25日発売
                      </Typography>
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「ふるさと写真館『生き生き おらんど昭和の子』―本社保存フィルムから」<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        林 剛史 編著<br />
                        Ａ４変型判／220ページ<br />
                        定価：2,420円（税込み）
                      </div>
                      <div class="fs90 line150 text-secondary">
                        1945（昭和20）年12月の本紙創刊以来、撮影・保存してきた報道写真を通じて地域の歩みをたどる写真集シリーズ「ふるさと写真館」の第２弾。戦後復興期―高度経済成長期の昭和の子どもたちにスポットを当て、学び、遊び、時に働き手として生きる姿を、変わりゆく社会の様子と共に伝える。文集「はちのへ」、八戸市こども詩集「花園」、三戸郡詩集「土手」などに収録された当時の小中学生の詩作品も紹介。<br />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12} className="p-2">
                      <div class="fs90 line150 text-secondary">
                        <Typography className="font-weight-bold my-2" variant="body1" component="h2">
                          ＜内容＞
                        </Typography>
                        <dl>
                          <dt>Ⅰ 学校・スポーツ</dt>
                          <dd>
                            入学式／登下校／プール／学校給食／運動会／授業／新制中学／スケート／電化製品／入学準備／受験・卒業
                          </dd>
                          <dt>Ⅱ 遊び・憩い</dt>
                          <dd>
                            日だまり／八戸遊園地／行楽／長根堤／魚捕り・釣り／水遊び／白銀海水浴場／湊川／三八城公園／風の子／雪遊び／路上の遊び
                          </dd>
                          <dt>Ⅲ 季節・歳時</dt>
                          <dd>
                            春めく海辺／こどもの日／物売り／七夕／真夏の海辺／お盆／夏の一こま／八戸三社大祭／七五三／クリスマス／年末年始／節分／えんぶり／ひな祭り
                          </dd>
                          <dt>Ⅳ 地域・暮らし</dt>
                          <dd>
                            丸美屋デパート／縁日・サーカス／イカの街／日米交流／労働作業／募金活動／紙芝居／働く親のそばで／保健衛生／乳幼児医療／保存食／集団就職
                          </dd>
                        </dl>
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/olympic.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2 text-danger" variant="body1" component="h2">
                        2021年8月13日発売
                      </Typography>
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「特別報道写真集 東京オリンピック2020」<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        Ａ４判／192ページ<br />
                        定価：1,650円（税込み）
                      </div>
                      <div class="fs90 line150 text-secondary">
                        約200カ国・地域から集まったアスリートたちが熱戦を繰り広げた東京大会。感動、熱気、興奮をそのままに、日本選手の活躍ぶりを余すところなく収録した永久保存版。全競技・種目を網羅し、トーチリレーのダイジェストも掲載。オールカラー。
                        主な掲載内容：開会式、メダル獲得日本選手、各競技のハイライト、種目別競技結果、日本選手団名簿、閉会式<br />
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/dekoboko.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2 text-danger" variant="body1" component="h2">
                        2021年7月15日発売
                      </Typography>
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「凸凹の書」<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        俊文書道会 著<br />
                        Ｂ５変型判／168ページ<br />
                        定価：２,750円（税込み）
                      </div>
                      <div class="fs90 line150 text-secondary">
                        障害の有無にかかわらずに誰もが書を楽しめるようにと、青森県八戸市で1999年に産声を上げたボランティア書道教室「俊文（しゅんぶん）書道会」。やりがいや発表する喜びを会員に感じてもらうため、定期作品展「書の発表会」を毎年開催しているほか、ユニークなテーマを掲げた企画展にも積極的に取り組む。その活動は、障害児教育、障害者アート、ノーマライゼーションの観点からも全国的な注目を集めている。<br />
                        俊文書道会20周年を記念して企画された本書に収録されたのは、人生や日常に対する愛しい思いや、ユーモア、優しさにあふれる作品計71点。西里俊文代表の「でこぼこがあるとつい削りたくなるが、削らずに磨きをかける」という指導方針の下、思いを筆に託して会員がつくり上げた作品は、見る人の心に寄り添い、前向きな気持ちにさせてくれる温かな魅力でいっぱい。障害のある人・ない人、大人から子どもまで、会員みんなの思いが詰まった、何度も見返したくなる珠玉の作品集。<br />
                        帯文の執筆は、国内外で活躍する美術家・奈良美智氏。<br />
                        <div className="my-2">
                          朝日のように力強く<br />
                          月の光のように繊細<br />
                          面と向かって正直で<br />
                          元気が出てくるんだ<br />
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/sengoku-nanbushi.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2 text-danger" variant="body1" component="h2">
                        2021年6月16日発売
                      </Typography>
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「戦国の北奥羽南部氏」<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        共著<br />
                        熊谷 隆次（八戸工業大学第二高校教諭）<br />
                        滝尻 侑貴（八戸市立図書館主査兼学芸員）<br />
                        布施 和洋（南部町教育委員会社会教育課史跡対策室総括主査）<br />
                        柴田 知二（二戸市教育委員会文化財課副主幹）<br />
                        野田 尚志（三戸町教育委員会事務局史跡対策班長）<br />
                        船場 昌子（八戸市博物館主幹）<br />
                        Ａ５判／236ページ<br />
                        定価：２,640円（税込み）
                      </div>
                      <div class="fs90 line150 text-secondary">
                        中世から明治維新に至るまで500年以上にわたり、ほぼ同じ地域を治め続けた北奥羽の一族・南部氏。青森県東部と岩手県にまたがる一帯に残る「南部地方」という呼び名は、南部氏に由来したものである。全国でも稀有なほど地域に深く根付いた南部氏は、権謀術数渦巻く戦国の世をどう生き、他の権力の干渉を受けずに長い歴史を築いたのか。<br />
                        南部氏の通史を扱った待望の新著である本書は、歴史学と考古学の研究者６人が、一次史料の再検証と最新の研究成果から、その実像に迫った。三戸南部氏が惣領的立場に至るまでの過程や、一戸～九戸を治め、集団的安全保障体制「一家」を構成した「戸」の領主間の関係、中央政権とのつながり、津軽での争乱、九戸一揆…。時に新しい仮説を提示しながらの多角的な考察は、歴史への好奇心をかき立てる。<br />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12} className="p-2">
                      <div class="fs90 line150 text-secondary">
                        <Typography className="font-weight-bold my-2" variant="body1" component="h2">
                          ＜目次より＞
                        </Typography>
                        <dl>
                          <dt>はじめに</dt>
                          <dt>Ⅰ 鎌倉・南北朝期の南部氏</dt>
                          <dd>
                            糠部と「戸」／南部氏の始まり／師行と根城／南朝への忠節／南北朝期の三戸氏 Ⅰ～Ⅳ／室町幕府との関係
                          </dd>
                          <dt>Ⅱ 室町幕府下の南部氏～安東氏との抗争と「戦国大名」化</dt>
                          <dd>
                            安東氏との戦い／田名部合戦／実在した三戸当主―信義／実在した三戸当主―信時／信時と家中／戦国争乱の始まり／安信と糠部の人々の祈り／三戸氏と「戸」の領主／「戦国大名」三戸氏の成立／五戸浅水城主南信義／八戸氏と新田盛政／天文期の「浪岡御所」／津軽八戸領／「南部信長」は誰か
                          </dd>
                          <dt>Ⅲ 南部氏「家督」晴政の戦い</dt>
                          <dd>
                            晴政という男 Ⅰ～Ⅱ／永禄期糠部の争乱／北・南氏包囲網／「家督」晴政と領主たち／「戸」の領主間の対立／鹿角郡合戦 Ⅰ～Ⅲ ／「斯波御所」と晴政／北奥の領主と室町将軍／織田信長と晴政／信直の家督就任
                          </dd>
                          <dt>Ⅳ 南部信直の決断～豊臣政権の奥羽仕置と九戸一揆</dt>
                          <dd>
                            信直と「取次」前田利家／信直の南下政策／安東氏統一と湊合戦／浅利氏と比内／津軽為信と久慈氏／津軽の危機／信直と為信挙兵／為信の津軽統一／奥羽仕置―南部内七郡／奥羽仕置―妻子在京・検地・諸城破却／奥羽仕置―「異儀」に及ぶ者の「成敗」／奥羽仕置の波紋／九戸政実の挙兵／九戸一揆と櫛引氏／豊臣軍派遣と伊達政宗の調停／仕置軍到着／九戸落城／戦後処理／俊恕と八戸直栄
                          </dd>
                          <dt>Ⅴ 発掘された南部氏城館</dt>
                          <dd>
                          　聖寿寺館研究の最前線 Ⅰ～Ⅲ／考古学から見た九戸一揆／九戸城と福岡城／三戸氏の本城・三戸城 Ⅰ～Ⅲ／根城の考古学 Ⅰ～Ⅲ
                          </dd>
                          <dt>おわりに</dt>
                          <dt>中世南部氏関連年表</dt>
                        </dl>
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/kitaou-jinbutsuden.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2 text-danger" variant="body1" component="h2">
                        2021年3月31日発売
                      </Typography>
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「続きたおうう人物伝―近現代の歩み」<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        渡部 髙明 監修<br />
                        「続きたおうう人物伝」編集委員会 編<br />
                        Ｂ５判／288ページ<br />
                        定価：2,640円（税込み）<br />
                      </div>
                      <div class="fs90 line150 text-secondary">
                        過去は未来の道標（みちしるべ）―。幕末～平成の北奥羽で活躍した各分野の先人132人の足跡をたどり、業績を伝える。Ⅰ章では1995年刊行「きたおぅう人物伝―近代化への足跡」から73人、Ⅱ章では本紙連載「続きたおうう人物伝」の59人を紹介し、幅広い時代を網羅。ふるさとの礎を築いた人物たちの思いや生き様は、今を生きるためのヒントも与えてくれる。
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12} className="p-2">
                      <div class="fs90 line150 text-secondary">
                        <Typography className="font-weight-bold my-2" variant="body1" component="h2">
                          ＜内容＞
                        </Typography>
                        <dl>
                          <dt>Ⅰ章</dt>
                          <dd>蛇口伴蔵／新渡戸伝／橋本雪蕉／広沢安任／栃内吉忠／泉山吉平／小田為綱／大澤多門／岩泉正意／西有穆山／太田広城／大塚甲山／南部麻子／浦山太吉／小田嶋熊吉／永洞清吉／源晟／磯崎定吉／大町桂月／奈須川光宝／伊藤吉太郎／６代目橋本八右衛門／長谷川藤次郎／千葉クラ／前田利見／渡邊村男／種市良一／近藤元太郎／関春茂／西村喜助／江渡狄嶺／泉山貞義／永嶋暢子／神田重雄／沼舘愛三／前原寅吉／北村益／田中舘愛橘／吉田初三郎／羽仁もと子／国分謙吉／岩淵謙一／山内亮／夏堀源三郎／七尾英鳳／泉山岩次郎／川島雄三／石橋蔵五郎／北村小松／三上剛太郎／岩岡德兵衞／松尾馬奮／三船久蔵／亀徳しづ／木村靄村／２代目三浦萬吉／夏堀悌二郎／陸奥明／大下常吉／阿部真之介／小井川潤次郞／江口隆哉／橋本忠吉／出町嘉明／法師浜桜白／田村義三郎／寺山修司／泉山信一／木村秀政／松下正寿／野田健次郎／熊谷義雄／村上しゅら</dd>
                          <dt>Ⅱ章</dt>
                          <dd>
                            前田長吉／浅利熊記／盛田達三／白木茂／中村由太郎／細川重計／千葉元／塚原宏／岡本正雄／西山正治／米田一穂／中畑長次郎／神山恵介／小國英雄／村次郎／浅石大和／佐々木泰南／上村忠郎／鷹山宇一／寺下力三郎／和井田登／夏堀正元／小井田幸哉／馬場のぼる／相米慎二／木村義男／小泉紫峰／杉本行雄／豊山千蔭／北村正●／鏡里（立田川親方）／菅野暎子／福田進／昆野清一／工藤欣一／河村静香／林みどり／大下由宮子／池田修一／秋山皐二郎／安藤睦夫／高橋倉蔵／中里進／金子善兵衛／岩舘義博／福田繁雄／吉田昌平／三浦哲郎／豊島和子／髙島成侑／武輪武一／正部家種康／福田正／松尾官平／中里信男／小寺隆韶／豊島弘尚／田中忠三郎／三浦福壽<br />
                            ※●字は「哉」の右下に「ノ」が付かない異体字
                          </dd>
                        </dl>
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/shouwa-zanzou.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2 text-danger" variant="body1" component="h2">
                        2020年12月15日発売
                      </Typography>
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「ふるさと写真館『昭和残像 人々と暮らし』ー本社保存フィルムから」<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        林 剛史 著<br />
                        Ａ４変型判／208ページ<br />
                        定価：2,420円(税込み)<br />
                      </div>
                      <div class="fs90 line150 text-secondary">
                        1945（昭和20）年12月の本紙創刊以来、撮影・保存してきた報道写真を通じて地域の戦後史をつづる写真集。変わりゆく世相風俗や、新しい時代をたくましく生きる人々を捉えた、昭和30年代を中心とした約200枚を収録。随想や当時の本紙記事を併せて掲載し、より多面的に時代の空気を伝える。本紙創刊75周年記念出版。
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12} className="p-2">
                      <div class="fs90 line150 text-secondary">
                        <Typography className="font-weight-bold my-2" variant="body1" component="h2">
                          ＜内容＞
                        </Typography>
                        <dl>
                          <dt>Ⅰ 社会・交通</dt>
                          <dd>ごみ／選挙／昼休み／ウミネコ／基地の町 八戸／飲食・喫茶／密造酒／宝くじ／はかる／ガンガラ部隊／路線バス／クルマ／オート三輪</dd>
                          <dt>Ⅱ 娯楽・スポーツ</dt>
                          <dd>ラジオ／テレビ／パチンコ／レコード／盛り場／踊る／種差海岸／八戸 長根球場／ゴルフ</dd>
                          <dt>Ⅲ 衣食住</dt>
                          <dd>パーマ／食生活／洗濯／傘／ファッションショー／八戸せんべい／干す／手わざ</dd>
                          <dt>Ⅳ 歳時・農事</dt>
                          <dd>花見／春耕／田植えのころ／神明宮（八戸）のおさかり／八戸七夕まつり／八戸三社大祭／お盆のころ／稲刈りのころ／歳末風景／正月点景／成人式／八戸えんぶり／春の雪</dd>
                        </dl>
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/nukanobu-33hudasho.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「奥州南部観音霊場巡り　糠部三十三札所」<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        滝尻 善英 著<br />
                        Ａ５判／184ページ<br />
                        定価：2,200円（税込み）<br />
                      </div>
                      <div class="fs90 line150 text-secondary">
                        一番札所・寺下観音堂（階上町）から三十三番札所・天台寺観音堂（二戸市）まで、青森県南、岩手県北に所在する由緒ある観音霊場を紹介。由来や歴史、見どころをはじめ、参拝方法や身支度などを分かりやすく解説する。秘仏などの貴重な写真も多数。地域における民間信仰と巡礼の文化を伝える。持ち歩きに便利な「携帯用巡礼案内」（約40センチ×59センチ）付き。オールカラー。
                      </div>
                      <br />
                      <div class="fs90 line150 text-secondary">
                        【一番札所】寺下観音堂＝階上町　【二番札所】是川 清水寺観音堂＝八戸市　【三番札所】松館 岡田観音堂　八戸市　【四番札所】島守 高山観音（高山神社と高松寺）＝八戸市　【五番札所】鮫 白浜観音堂＝八戸市　【六番札所】白銀 清水川観音堂＝八戸市　【七番札所】岩淵 新山権現堂観音（別雷神社）＝八戸市　【八番札所】新井田 浄生寺観音＝八戸市　【九番札所】糠塚 大慈寺観音堂＝八戸市　【十番札所】朔日町 来迎寺観音＝八戸市　【十一番札所】南宗寺横枕観音＝八戸市　【十二番札所】根城 隅の観音堂＝八戸市　【十三番札所】坂牛 坂牛観音堂（坂牛八幡宮）＝八戸市　【十四番札所】八幡 櫛引観音堂＝八戸市　【十五番札所】七崎山 徳楽寺観音（普賢院）＝八戸市　【十六番札所】斗賀 霊現堂観音（斗賀神社）＝南部町　【十七番札所】相内 相内観音堂＝南部町　【十八番札所】作和 外手洗観音堂＝南部町　【十九番札所】名久井 法光寺観音堂＝南部町　【二十番札所】鳥谷 矢立観音堂＝南部町　【二十一番札所】梅内 野瀬観音堂＝三戸町　【二十二番札所】恵光院 長谷観音堂＝南部町　【二十三番札所】門前 早稲田観音堂＝南部町　【二十四番札所】古町 隅ノ観音堂＝南部町　【二十五番札所】悟真寺観音堂＝三戸町　【二十六番札所】下田子 清水寺観音（真清田神社）＝田子町　【二十七番札所】七日市 釜淵観音堂＝田子町　【二十八番札所】福岡 岩谷観音堂＝二戸市　【二十九番札所】鳥越山 鳥越観音堂＝一戸町　【三十番札所】石切所 朝日山観音堂＝二戸市　【三十一番札所】晴山 観音林観音堂＝軽米町　【三十二番札所】一戸 実相寺観音堂＝一戸町　【三十三番札所】浄法寺町 天台寺観音堂＝二戸市　【消えた三十二番札所】似鳥（飯近山）の観音＝二戸市
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/aomori-s-machi-mura.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「青森県　昭和の町と村－大合併で消えた自治体の記録」<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        中園 裕 編<br/>
                        Ａ４判／260ページ<br/>
                        定価：2,970円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        昭和30年代に行われた「昭和の大合併」から約60年。かつて存在した青森県内110町村の歴史や逸話を、貴重な写真と共に紹介。Ａ３判の地図「町村合併促進法公布時の青森県市町村分布図（昭和28年）」「町村合併後の成果現況図（昭和35年）」綴じ込み。<br />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12} className="p-2">
                      <div class="fs90 line150 text-secondary">
                        <Typography className="font-weight-bold my-2" variant="body1" component="h2">
                          ＜対象町村＞
                        </Typography>
                        <dl>
                          <dt>◆三戸郡</dt>
                          <dd>館村　是川村　市川村　豊崎村　上長苗代村　大館村　島守村　中沢村　留崎村　斗川村　猿辺村　上郷村　戸来村　野沢村　向村　平良崎村　名久井村　北川村　地引村　田部村　浅田村　川内村</dd>
                          <dt>◆上北郡</dt>
                          <dd>三本木町　大深内村　藤坂村　四和村　十和田町　大三沢町　浦野館村　甲地村</dd>
                          <dt>◆下北郡</dt>
                          <dd>大湊町　田名部町</dd>
                          <dt>◆中津軽郡</dt>
                          <dd>清水村　千年村　堀越村　豊田村　和徳村　藤代村　船沢村　高杉村　新和村　裾野村　大浦村　駒越村　東目屋村</dd>
                          <dt>◆南津軽郡</dt>
                          <dd>石川町　蔵館町　大光寺町　柏木町　尾崎村　町居村　竹館村　猿賀村　光田寺村　畑岡村　十二里村　富木館村　中郷村　浅瀬石村　山形村　六郷村　五郷村　女鹿沢村　野沢村　大杉村</dd>
                          <dt>◆東津軽郡</dt>
                          <dd>筒井町　大野村　荒川村　高田村　横内村　浜館村　原別村　東岳村　野内村　小湊町　東平内村　西平内村　新城村　奥内村　後潟村　一本木村</dd>
                          <dt>◆北津軽郡</dt>
                          <dd>脇元村　相内村　内潟村　武田村　喜良市村　嘉瀬村　飯詰村　三好村　中川村　長橋村　松島村　栄村　七和村　梅沢村　六郷村　沿川村　小阿弥村</dd>
                          <dt>◆西津軽郡</dt>
                          <dd>水元村　鳴沢村　舞戸村　中村　赤石村　大戸瀬村　越水村　柴田村　川除村　出精村　館岡村　十三村</dd>
                        </dl>
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                {/*
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/reiwa-koushitsu.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「天皇陛下御即位記念 特別報道写真集 令和の皇室」<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        共同通信社、デーリー東北新聞社　編<br/>
                        Ａ４変型判／154ページ<br/>
                        定価：本体2,000円＋税<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        2019年５月１日に天皇陛下は即位され、令和の時代となった。この即位に始まり10、11月の華々しい関連行事まで、国民と共に歩まれる両陛下のお姿を余すことなく収録。巻末に青森県を訪れた両陛下の写真をご覧いただける特別ページも挿入。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                */}
                {/* 
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/suzuranyama.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        写真集「青森里山案内　鈴蘭山」<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        小沢 純二　著<br/>
                        Ａ４変型判／128ページ<br/>
                        定価：2,200円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        十和田市の市街地に近い三本木一本木沢地区に広がる約20haの原野「鈴蘭山」。近年になって、青森県内最大級のコナラが群生していることが確認された。多様な命を育む里山の四季の風景と、地域の生活を支えてきた歴史を伝える。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                 */}
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/tsuredurenikki.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        高橋弘希の徒然日記<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        高橋 弘希　著<br/>
                        Ａ５変型判／108ページ<br/>
                        定価：1,540円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        十和田市生まれの芥川賞作家によるエッセー集。弊紙掲載の同名連載を中心に収録。日々の暮らしや創作活動の裏話、青森にまつわるエピソードなどを軽妙な文体でつづる。味わい深いイラスト（一部除く）も著者本人による。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                {/*
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/2018baseball-sum-graph01.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        高校野球グラフ２０１８<br/>
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        デーリー東北新聞社　編<br/>
                        Ａ４判／92ページ<br/>
                        定価：本体926円＋税<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        １回戦から決勝までの５８試合を臨場感ある写真とデータで紹介。全国大会１００回の節目に当たり、県勢の闘いを振り返る企画や、１９６９年に三沢高エースとして全国準優勝を果たした太田幸司氏（プロ野球解説者）のインタビューも収録。８月２日発売。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                */}
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/umi-wo-tsunagumichi.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        海をつなぐ道－八戸藩の海運の歴史
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        三浦 忠司　著<br/>
                        Ａ５判／268ページ<br/>
                        定価：2,420円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        地元廻船団を組織して江戸、大坂へ－。２万石の小藩にすぎなかった八戸藩が、新たな産物を武器に、全国にいかにして食い込んでいこうとしたのか。現在の産業都市の礎となった江戸時代における海運の歩みを、数々の資料を基に読み解く。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/chiteki-henreki.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        私の知的遍歴－哲学・時代・創見－
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        山脇 直司　著<br/>
                        四六判／244ページ<br/>
                        定価：1,430円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        　時に軽妙、時に真摯（しんし）に－。公共哲学の第一人者による書き下ろしの自分史と、本紙コラム「私見創見」を収録。高校卒業までを過ごした古里八戸での思い出から、激動する“世界の今”までを硬軟織り交ぜてつづる。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/satoyama-wo-aruku.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        北奥羽　里山を歩く
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        高橋 晃 著<br/>
                        Ａ４変型判／184ページ<br/>
                        定価：1,980円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        多様な命を育む身近な自然を案内し、植生の特徴や暮らしとの関わりを解説する。ミニコラム風の植物紹介や用語解説も収録。ガイド本として活用できるほか、風景や花の写真をゆっくり眺めるだけでも楽しい。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                {/*
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/yomigaeru-jouka.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        よみがえる八戸城下－復元絵図と藩士の由緒
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        三浦 忠司　著<br/>
                        Ａ４判／134ページ、差し込み図１枚<br/>
                        城下絵図の複製・復元図付き（各Ａ１判）<br/>
                        箱入り、定価：本体3,000円＋税<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        江戸時代末期の絵図「文久改正　八戸御城下略図」や史料「系譜書上」を基に、城下の屋敷配置や藩士の来歴を明らかに。時を超えて町と人の実像を伝える。各家が手書きした家紋も掲載。家計調査や街歩きに役立つ一冊。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                */}
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/hachinohehan.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        八戸藩の歴史をたずねて
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        三浦 忠司　著<br/>
                        Ａ５判／304ページ<br/>
                        定価：1,885円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        八戸歴史研究会会長を務める著者が、新しい観点から郷土の歩みをひもといた。政治史のほか、社会の動向や人々の暮らしにも着目し、八戸藩の歴史を立体的に構成。東京に残る、ゆかりの地も探訪。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/tanesashi-guide.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        三陸復興国立公園　種差海岸ガイドブック
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        デーリー東北新聞社　編<br/>
                        Ａ４判／70ページ<br/>
                        定価：1,257円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        2013年５月に三陸復興国立公園に指定された、八戸市が誇る国の名勝・種差海岸。天然芝生地が広がり、海浜植物や山野草が咲き乱れる〝奇跡の海辺〟の魅力や歴史を紹介。便利な探訪マップ付き。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/nagisa.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        なぎさ　たべもの塾
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        なぎさ なおこ　著<br/>
                        Ａ４変型判／112ページ<br/>
                        定価：1,257円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        親子で楽しめる、かわいくて、おいしい野菜の絵本。24種の野菜を季節ごとに分け、栄養や特徴、すぐに作れる簡単レシピを紹介。食と健康について考えるきっかけにも。野菜をもっと好きになろう！
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/renaissance.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        ＜はちのへ・るねさんす＞の風景
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        山根 勢五　著<br/>
                        Ａ４判／80ページ<br/>
                        定価：1,885円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        戦時中の閉塞感から解放された昭和20～30年代。個性豊かな面々が互いに刺激し合い、新たな文化の創造に希望を膨らませた。著者が見聞した豊富な逸話を通して、文化復興の息吹を生き生きと伝える。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                {/*
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/rongo.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        論語絵本
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        森 華　訳・絵、礪波 護　監修<br/>
                        Ａ５変型判／160ページ<br/>
                        定価：本体1,500円＋税<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        中国の思想家・孔子の言行録「論語」の絵本。500章の中から91章を厳選し、「よろこび」「いきる」など八つのテーマに分けて教えを紹介。簡潔な現代語訳で、人のあるべき姿を分かりやすく説く。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                */}
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/hyakku-hyakkei.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        四季　北奥羽百句百景
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        三ヶ森 青雲　著<br/>
                        Ａ４判／224ページ<br/>
                        定価：2,640円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        北奥羽を代表する俳人の秀句100句を選び、ゆかりの地などを巡った取材記に、情緒あふれる写真を添えた。豊かな自然や風土、先人の足跡が鮮やかに浮かび上がり、古里への思いが一層深まる一冊。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                {/*
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/genkai-syuraku.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        全国12地方紙共同出版　限界集落と地域再生
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        大野 晃　著<br/>
                        Ａ５版／316ページ<br/>
                        定価：1,600円＋税<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        ｢限界集落｣……その数、日本列島に7878集落（国土交通省調査）。うち、2643集落は崩壊の危機に瀕している。「むら」の消滅は自治体の命運をも握る急がれる再生の手だて。「限界集落」の概念を打ち出した著者が再生へのビジョンを提言する。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                */}
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/sakana-monogatari.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        八戸魚物語
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        石戸 芳男　編<br/>
                        Ｂ６判／230ページ<br/>
                        定価：2,640円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        全国有数の水産都市である八戸市。港に水揚げされる魚介類161種を取り上げた初の図鑑。分類、形態、分布、生態のほか、調理法や味の特徴などについても解説した。巻末に八戸近海の魚類目録を収録。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/miurateruto-no-sekai.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        作家生活50年　三浦哲郎の世界
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        デーリー東北新聞社　編<br/>
                        Ａ４判／76ページ<br/>
                        定価：1,257円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        磨き抜かれた文体で人生の哀歓をつむいだ芥川賞作家・三浦哲郎。その文学と人となりを、より深く知るためのガイドブック。作家所蔵の私的写真や自筆年譜も掲載。エッセイ特別選「狐のあしあと」収録。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/terayama-kaetteoide.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        回想・寺山修司　百年たったら帰っておいで
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        九條 今日子　著<br/>
                        四六判／232ページ<br/>
                        定価：1,650円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        青森が生んだ奇才・寺山修司。時代が変わっても、その唯一無二の世界は色あせない。公私にわたるパートナーだった元妻がつづる、寺山の素顔とは。奇跡的な男女の結び付きを明かした、愛に満ちた回想録。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/mutsu-ogawara.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        検証　むつ小川原の30年
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        江波戸 宏　著<br/>
                        Ａ５判／393ページ<br/>
                        定価：本体2,933円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        「下北原子力半島」の原点である、むつ小川原開発計画。破綻した巨大開発の30年余を取材記者が検証した。国家石油備蓄基地や核燃施設立地に至る経緯、地元の混乱－。知られざる事実の貴重な記録。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
              </List>
            </Paper>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北選書
          </Typography>
          <Box my={4}>
            <Paper>
              <List component="nav" aria-label="main mailbox folders">
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/aomori-koutsu.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「青森県の交通史」
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        中園　裕　編<br/>
                        Ａ５変型判／134ページ<br/>
                        定価：1,320円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        地域を結ぶ公共交通は、今も昔も必要不可欠な市民の足。その歴史を機関・施設や出来事別に、分かりやすい文章で紹介。新時代を展望するヒントにも。貴重な写真も多数掲載。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                {/*
                <Divider variant="middle" />
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/tensyo02.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「天鐘2015 １～６月」、「同 ７～12月」
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        デーリー東北新聞社論説委員会　著<br/>
                        Ａ５変型判／「１～６月」294ページ<br/>
                        「７～12月」282ページ<br/>
                        各定価：本体1,300＋税<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        “新聞の顔”といわれる１面コラムを、半年分ごとに収録。時事ニュースや身近な出来事・話題を題材に、論説委員が柔らかい筆致で喜怒哀楽をつづる。巻末に「北奥羽 主なニュース」掲載。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                */}
                {/*
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/tensyo01.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        「天鐘2014 １～６月」、「同 ７～12月」
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        デーリー東北新聞社論説委員会　著<br/>
                        Ａ５変型判／「１～６月」282ページ<br/>
                        「７～12月」294ページ<br/>
                        定価：本体1,200円＋税<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        “新聞の顔”といわれる１面コラムを、半年分ごとに収録。時事ニュースや身近な出来事・話題を題材に、論説委員が柔らかい筆致で喜怒哀楽をつづる。巻末に「北奥羽 主なニュース」掲載。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider variant="middle" />
                */}
                {/* 
                <ListItem button>
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={3} className="p-2">
                      <img src="/images/book/hudoki.jpg" className="img-fluid" />
                    </Grid>
                    <Grid item xs={12} md={9} className="p-2">
                      <Typography className="font-weight-bold my-2" variant="h6" component="h2">
                        南部　暮らしの風土記
                      </Typography>
                      <div className="my-2 fs90 line150 font-weight-bold">
                        古里 淳　著<br/>
                        Ａ５変型判／164ページ<br/>
                        定価：880円（税込み）<br/>
                      </div>
                      <div class="fs90 line150 text-secondary">
                        厳しい風土の中で、たくましく生きてきた南部地方の人々。味噌（みそ）玉、えんつこ、おしらさま、千歯こき…。懐かしい食文化や風習、民具などに込められた先人の知恵と思いを今に伝える。
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                */}
              </List>
            </Paper>
          </Box>
        </Box>
      </div>
    </div>
  );
}

export default Book;
